import { Component, OnInit, OnDestroy, Input, Optional, Injectable, ChangeDetectorRef } from '@angular/core'
import { Item } from '../../entity/entities';
import { FormPasswordDirectiveProperty } from '../../entity/form/formPasswordDirective.property';
import { GSBaseControl } from '../gs.base.control';

@Component({
  selector: 'gs-password-directive',
  templateUrl: './gs.password-directive.control.html',
  styles: [`
    :host ::ng-deep .p-float-label.has-validation-icon .p-password .pi-eye,
    :host ::ng-deep .p-float-label.has-validation-icon .p-password .pi-eye-slash {
      right: 45px !important;
    }
    :host ::ng-deep .p-inputwrapper:not(.p-inputwrapper-filled) .p-password .pi-eye,
    :host ::ng-deep .p-inputwrapper:not(.p-inputwrapper-filled) .p-password .pi-eye-slash {
      display: none !important;
    }
    :host ::ng-deep .p-password-full-width {
      width: 100%;
      display: inline-block;
    }
  `]
})
@Injectable()
export class GSPasswordDirectiveControl extends GSBaseControl implements OnInit, OnDestroy{

  //#region -------Properties
  @Input() showPassword = false;
  //#endregion


  //#region -------Constructor
  constructor(@Optional() prop: FormPasswordDirectiveProperty, @Optional() item: Item, private changeDr: ChangeDetectorRef) {
    super(changeDr);
    this.property = prop;
    this.item = item;
  }
  //#endregion

  //#region -------NG Eents
  ngOnInit() {
  }

  ngOnDestroy() {
  }

  //#endregion

  //#region -------UI Events
  show() {
    this.showPassword = !this.showPassword;
  }

  change(e) {
    if (e || e == '') {
      let previousValue = this.data[this.name];
      this.value = e;
      this.item.reCheckDirty();
      this.onChange.emit({ propertyName: this.name, previousValue: previousValue, newValue: this.value, event: e, item: this.item, property: this.property });
      this.property.changed.emit({ propertyName: this.name, previousValue: previousValue, newValue: this.value, event: e, item: this.item, property: this.property });
    }
  }
  //#endregion

  //#region -------Private
  //#endregion
}
